moment = require 'moment'
{ doAction } = require './index'
_ = require 'lodash'


BEGIN_OBSERVATION = 'BEGIN_OBSERVATION'
CREATE_OBSERVATION = 'CREATE_OBSERVATION'
CREATE_OBSERVATION_CYCLE = 'CREATE_OBSERVATION_CYCLE'
CREATE_OBSERVATION_QUESTION_RESPONSES = 'CREATE_OBSERVATION_QUESTION_RESPONSES'
CREATE_STUDENT_OBSERVATION = 'CREATE_STUDENT_OBSERVATION'
CREATE_STUDENT_OBSERVATION_EVENT = 'CREATE_STUDENT_OBSERVATION_EVENT'
CREATE_TEACHER_OBSERVATION = 'CREATE_TEACHER_OBSERVATION'
CREATE_TEACHER_OBSERVATION_EVENT = 'CREATE_TEACHER_OBSERVATION_EVENT'
END_OBSERVATION = 'END_OBSERVATION'
END_OBSERVATION_CYCLE = 'END_OBSERVATION_CYCLE'
END_STUDENT_OBSERVATION = 'END_STUDENT_OBSERVATION'
END_STUDENT_OBSERVATIONS = 'END_STUDENT_OBSERVATIONS'
END_TEACHER_OBSERVATION = 'END_TEACHER_OBSERVATION'
FETCHED_OBSERVATIONS = 'FETCHED_OBSERVATIONS'
FETCHED_RECENT_OBSERVATIONS = 'FETCHED_RECENT_OBSERVATIONS'
FETCHING_OBSERVATIONS = 'FETCHING_OBSERVATIONS'
FETCHING_RECENT_OBSERVATIONS = 'FETCHING_RECENT_OBSERVATIONS'
FETCHING_STUDENT_EVENT_TYPES = 'FETCHING_STUDENT_EVENT_TYPES'
FETCHED_STUDENT_EVENT_TYPES = 'FETCHED_STUDENT_EVENT_TYPES'
FETCHING_TEACHER_EVENT_TYPES = 'FETCHING_TEACHER_EVENT_TYPES'
FETCHED_TEACHER_EVENT_TYPES = 'FETCHED_TEACHER_EVENT_TYPES'
PAUSE_STUDENT_OBSERVATIONS = 'PAUSE_STUDENT_OBSERVATIONS'
PAUSE_TEACHER_OBSERVATION = 'PAUSE_TEACHER_OBSERVATION'
REHYDRATE_OBSERVATION = 'REHYDRATE_OBSERVATION'
SCORING_OBSERVATION = 'SCORING_OBSERVATION'
SCORED_OBSERVATION = 'SCORED_OBSERVATION'
UNPAUSE_STUDENT_OBSERVATIONS = 'UNPAUSE_STUDENT_OBSERVATIONS'
UNPAUSE_TEACHER_OBSERVATION = 'UNPAUSE_TEACHER_OBSERVATION'
UPDATED_OBSERVATION = 'UPDATED_OBSERVATION'
UPDATING_OBSERVATION = 'UPDATING_OBSERVATION'
UPLOADING_OBSERVATION = 'UPLOADING_OBSERVATION'
UPLOADED_OBSERVATION = 'UPLOADED_OBSERVATION'

module.exports = {
	BEGIN_OBSERVATION
	CREATE_OBSERVATION
	CREATE_OBSERVATION_CYCLE
	CREATE_OBSERVATION_QUESTION_RESPONSES
	CREATE_STUDENT_OBSERVATION
	CREATE_STUDENT_OBSERVATION_EVENT
	CREATE_TEACHER_OBSERVATION
	CREATE_TEACHER_OBSERVATION_EVENT
	END_OBSERVATION
	END_OBSERVATION_CYCLE
	END_STUDENT_OBSERVATION
	END_STUDENT_OBSERVATIONS
	END_TEACHER_OBSERVATION
	FETCHED_OBSERVATIONS
	FETCHED_RECENT_OBSERVATIONS
	FETCHING_OBSERVATIONS
	FETCHING_RECENT_OBSERVATIONS
	FETCHING_STUDENT_EVENT_TYPES
	FETCHED_STUDENT_EVENT_TYPES
	FETCHING_TEACHER_EVENT_TYPES
	FETCHED_TEACHER_EVENT_TYPES
	PAUSE_STUDENT_OBSERVATIONS
	PAUSE_TEACHER_OBSERVATION
	REHYDRATE_OBSERVATION
	SCORING_OBSERVATION
	SCORED_OBSERVATION
	UNPAUSE_STUDENT_OBSERVATIONS
	UNPAUSE_TEACHER_OBSERVATION
	UPDATED_OBSERVATION
	UPDATING_OBSERVATION
	UPLOADING_OBSERVATION
	UPLOADED_OBSERVATION

	beginObservation: ->
		return {
			type: BEGIN_OBSERVATION
		}

	endObservation: ->
		return {
			type: END_OBSERVATION
		}

	endStudentObservations: ->
		return {
			type: END_STUDENT_OBSERVATIONS
		}

	endStudentObservation: (studentId) ->
		return {
			type: END_STUDENT_OBSERVATION
			payload: {
				studentId: studentId
			}
		}

	endTeacherObservation: ->
		return {
			type: END_TEACHER_OBSERVATION
		}

	fetchRecentObservations: (classroomId, teacherId, asOfDate = null) ->
		if !asOfDate then asOfDate = moment().format('YYYY-MM-DD')

		url = "/api/observations/recent?classroom_id=#{classroomId}&teacher_id=#{teacherId}&as_of_date=#{asOfDate}"
		method = 'get'
		payload = null
		doingActionType = FETCHING_RECENT_OBSERVATIONS
		didActionType = FETCHED_RECENT_OBSERVATIONS
		failureMessage = 'Failed to retrieve recent observations'
		successMessage = null

		# For some reason, this API endpoint was written to return an object with string integers as the
		# keys.  Other places in the frontend depend on that non-standard structure, so I can't change it
		# at the API level until I'm ready to completely replace the bad design pattern used in the `api/`
		# folder, which should all have been done with actions instead.

		getSuccessPayload = (responseJson) =>
			observations = []
			Object.keys(responseJson.data).map (index) =>
				observations.push(responseJson.data[index])
			return { list: observations }

		doAction(url, method, payload, doingActionType, didActionType, failureMessage, successMessage, getSuccessPayload)

	fetchObservations: ->
		url = '/api/observations'
		method = 'get'
		payload = null
		doingActionType = FETCHING_OBSERVATIONS
		didActionType = FETCHED_OBSERVATIONS
		failureMessage = 'Failed to retrieve the list of observations from the server'
		doAction(url, method, payload, doingActionType, didActionType, failureMessage)

	createObservation: (observation) ->
		return {
			type: CREATE_OBSERVATION
			payload: {
				observation: observation
			}
		}

	rehydrateObservation: ->
		return {
			type: REHYDRATE_OBSERVATION
		}

	uploadObservation: (observation) ->
		if localStorage.getItem('currentObservation')
			url = '/api/observations'
			method = 'post'
			payload = {
				observation: {
					number_of_cycles: observation.number_of_cycles,
					student_minutes: observation.student_minutes,
					teacher_minutes: observation.teacher_minutes,
					created_at: observation.created_at,
					observation_date: observation.observation_date,
					student_observations: observation.student_observations,
					teacher_observations: observation.teacher_observations,
					observation_question_responses: observation.observation_question_responses,
					observation_cycles: observation.observation_cycles,
					gold_standard_observation_id: observation.gold_standard_observation_id
				},
				classroom_id: observation.classroom_id,
				teacher_id: observation.teacher_id,
				student_ids: observation.student_ids
			}
			doingActionType = UPLOADING_OBSERVATION
			didActionType = UPLOADED_OBSERVATION
			getSuccessPayload = (responseJson) => return responseJson.data

			doAction(url, method, payload, doingActionType, didActionType, null, null, getSuccessPayload)

	createObservationCycle: (observationCycle) ->
		return {
			type: CREATE_OBSERVATION_CYCLE
			payload: {
				observationCycle: observationCycle
			}
		}

	endObservationCycle: ->
		return {
			type: END_OBSERVATION_CYCLE
		}

	createStudentObservation: (studentObservation) ->
		return {
			type: CREATE_STUDENT_OBSERVATION
			payload: {
				studentObservation: studentObservation
			}
		}

	createStudentObservationEvent: (studentId, studentObservationEvent) ->
		return {
			type: CREATE_STUDENT_OBSERVATION_EVENT
			payload: {
				studentId: studentId
				studentObservationEvent: studentObservationEvent
			}
		}

	createTeacherObservation: (teacherObservation) ->
		return {
			type: CREATE_TEACHER_OBSERVATION
			payload: {
				teacherObservation: teacherObservation
			}
		}

	createTeacherObservationEvent: (teacherObservationEvent) ->
		return {
			type: CREATE_TEACHER_OBSERVATION_EVENT
			payload: {
				teacherObservationEvent: teacherObservationEvent
			}
		}

	createObservationQuestionResponses: (observationQuestionResponses) ->
		return {
			type: CREATE_OBSERVATION_QUESTION_RESPONSES
			payload: {
				observationQuestionResponses: observationQuestionResponses
			}
		}

	pauseStudentObservations: ->
		return {
			type: PAUSE_STUDENT_OBSERVATIONS
		}

	pauseTeacherObservation: ->
		return {
			type: PAUSE_TEACHER_OBSERVATION
		}

	unpauseStudentObservations: ->
		return {
			type: UNPAUSE_STUDENT_OBSERVATIONS
		}

	unpauseTeacherObservation: ->
		return {
			type: UNPAUSE_TEACHER_OBSERVATION
		}

	updateObservation: (observation) ->
		url = '/api/observations/' + observation.id
		method = 'PATCH'
		payload = observation
		doingActionType = UPDATING_OBSERVATION
		didActionType = UPDATED_OBSERVATION
		failureMessage = 'Failed to update the observation'
		doAction(url, method, payload, doingActionType, didActionType, failureMessage)

	scoreObservation: (scoredObservationID, goldStandardObservationID) ->
		url = '/api/observations/reliability?scored_observation_id=' + scoredObservationID + '&gold_standard_observation_id=' + goldStandardObservationID
		method = 'get'
		payload = null
		doingActionType = SCORING_OBSERVATION
		didActionType = SCORED_OBSERVATION
		failureMessage = 'Failed to score this observation'
		successMessage = null
		getSuccessPayload = (responseJson) => return responseJson.data
		doAction(url, method, payload, doingActionType, didActionType, failureMessage, successMessage, getSuccessPayload)

	fetchStudentEventTypes: () ->
		url = '/api/observations/student_event_types'
		method = 'get'
		payload = null
		doingActionType = FETCHING_STUDENT_EVENT_TYPES
		didActionType = FETCHED_STUDENT_EVENT_TYPES
		failureMessage = 'Failed to retrieve student moves'
		successMessage = null
		doAction(url, method, payload, doingActionType, didActionType, failureMessage, successMessage)

	fetchTeacherEventTypes: () ->
		url = '/api/observations/teacher_event_types'
		method = 'get'
		payload = null
		doingActionType = FETCHING_TEACHER_EVENT_TYPES
		didActionType = FETCHED_TEACHER_EVENT_TYPES
		failureMessage = 'Failed to retrieve teacher moves'
		successMessage = null
		doAction(url, method, payload, doingActionType, didActionType, failureMessage, successMessage)
}



// WEBPACK FOOTER //
// ./frontend/olos/js/actions/observations.coffee